module.exports = __webpack_public_path__ + "img/06.91f98de7.jpg";